<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-sacrifice-icon01.svg" alt="*" />あなたの潜在意識
				</span>
			</div><!-- end .type -->
			<div class="cover">
					他人本位{{sacrificeMindResult.percentageLeft}}%、自分本位{{sacrificeMindResult.percentageRight}}%
			</div><!-- end .cover -->	
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自分の身勝手さの中にも、きちんとした価値をつけることで、あなたはどんどん周囲を巻き込んでいく</h2>
			<img src="../assets/result-detail-sacrifice-outright01.svg" alt="*" class="visual" />
			<div class="caption">
				自分のやりたいことが、周囲や環境にどんな価値を持つのか、常に考えるべきだ
			</div><!-- end .caption -->
			<p>今回の診断で、あなたの潜在意識は自己本位志向が強いことが分かりました。あなたは内向度が低いため、この潜在意識と相まって、自分の気持ちのまま、自分の想ったまま、相手と接していく特徴が強いと言えるでしょう。</p>
			<p>よく言えば、あなたは相手を自然に巻き込む力を持っていますが、悪く言えば、あなたは相手にとって、「自分勝手」と不満を持たれる可能性を常に秘めている人材です。</p>
			<p>あなた自身の貫きたいことが、多くの人にとっての需要があったり、社会的に価値がある場合、あなたの自分勝手な行動というのは、周囲を巻き込む有難いカリスマとなるでしょう。自分本位な行動を、相手にとって価値のあることに変えていくことが非常に大切になります。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>目に見えるハイクオリティを突き詰めることで、あなたの潜在意識は圧倒的に生かされていく</h2>
			<img src="../assets/result-detail-sacrifice-outright02.svg" alt="*" class="visual" />
			<div class="caption">
				何度打たれても立ち上がるタフさによって、あなたには必ずターニングポイントが訪れる
			</div><!-- end .caption -->
			<p>自分本位意識が強い人が社会の中で突き抜けた存在になるのは、たいてい、その当人が目に見える分かりやすい魅力やクオリティを持っているケースです。</p>
			<p>正直、容姿が優れているだけでも、自分勝手な行動が相手にとってプラスになってしまいますよね。目に見えやすい能力やクオリティほどあなたの自己本位性と外向性を大きな掛け算にします。</p>
			<p>歌が上手い、絵が描けるといった成果や実績が分かりやすいものも良いでしょう。一人でできるものは、自分の成果に強制的に向き合うことになるため、自己本位タイプにはぴったりです。</p>
			<p>そして、大事なことは、やりっ放しにしないこと。曖昧に進めないことです。日々、質を高め続けることを強く意識し、今の自分の質に疑問を持ちましょう。他人から自分の弱点や短所を素直かつ積極的に聞き、受け入れましょう。受け入れて、さらに新たな視野や視点でトライしていきましょう。</p>
			<p>ハイクオリティで自己本位な人は、相手に価値を出しながらも、自分の都合もうまくバランスよく取り込んで、相手も自分も両者が幸せになる世界を、どんなステージでも築けるようになっていきます。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>「思い込み」と上手に付き合えば、外向性と自己本位性が大きな長所になる</h2>
			<img src="../assets/result-detail-sacrifice-outright03.svg" alt="*" class="visual" />
			<div class="caption">
				自分を定期的に疑い、思い込みのスイッチをオンとオフのバランスを取っていく
			</div><!-- end .caption -->
			<p>外向性と自己本位性が強いタイプのあなたは、他のタイプに比べて、「思い込み」がかなり多い傾向にあります。あなたがどんなに注意深く考え込んだとしても、それすらも、大きな見当違いや勘違いの可能性があるのです。</p>
			<p>自己本位性が高くなれば、情報を自己都合で解釈します。外向性が高くなれば、思考を深める前にアウトプットをしがちになります。その結果、このタイプの人が、１つ1つの情報や思考の繰り返しで起こした行動は、かなりの見当違いになることは多いのです。</p>
			<p>逆に、思い込みの力の長所は、そのまま行動を突っ切ることができることです。つまり、既に方法が正しい場合、あなたは如実な成果を出せるタイプなのです。</p>
			<p>だから、あなたは戦略的に思い込みのスイッチをオンオフするようにして下さい。「ここは思い込みだとしても一気にやってみよう！」とあえて考えずに行動したり、「もしかして、これは思い込みかもしれない」と疑ったりしていくのです。このバランス感覚こそが、あなたの外向性と自己本位性を長所にしていきます。</p>
			<p>思い込んだままでいたり、思い込みを疑ったり、この2つを定期的に繰り返すことは、あなたの人間関係における結果を大きく変えます。特に深く長い関係を続けるために極めて重要です。</p>
			<p>最初に短時間で相手と打ち解けたり、仲良くなるのは上手なったりするのは得意なのに、なかなか関係が長続きしないのもこのタイプにありがちです。自分がそもそも思い込み体質であるという前提で行動すれば、あなたはより一層多くの人に愛され、あなたの自己本位性や外向性は、味わいや魅力へと様変わりしていきます。</p>
		</div><!-- end .sentence -->
	</div><!-- end .contents -->			
</template>
		

<script>


export default {
	name: 'ResultDetailSacrificeOutRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
